import React from 'react';
import PropTypes from 'prop-types';

import Row from 'zignal-landscape/lib/Row';
import Col from 'zignal-landscape/lib/Col';
import GridContent from 'zignal-landscape/lib/GridContent';
import Link from 'zignal-landscape/lib/Link';
import Select from 'zignal-landscape/lib/Select';
import themeable from 'zignal-landscape/lib/themeable';

import range from 'lodash/range';
import noop from 'lodash/noop';

const selectStyles = {
  singleValue: (base) => ({
    ...base,
    padding: 0,
    lineHeight: 'inherit'
  }),
  valueContainer: (base) => ({
    ...base,
    padding: '0 7px'
  })
};

const InternalAdminsTableFooter = ({
  styles, totalRecords, totalTablePages, elementsPerPage,
  selectedPageNumber, handleItemsPerPageChange,
  handleTableNavChange, toPageCount, fromPageCount,
  startPaginationRange, endPaginationRange
}) => {

  const pagesDisplayedInfo = toPageCount > 0
    ? `Showing ${fromPageCount} to ${toPageCount} of ${totalRecords} Internal Admins`
    : '';
  const pagesButtons = range(startPaginationRange, endPaginationRange).map((val) => {
    const pageNumber = val + 1;
    const linkType = pageNumber === selectedPageNumber ? 'default' : 'cancel';
    const onClickFn = pageNumber === selectedPageNumber ? noop : handleTableNavChange;
    return (
      <div key={val} className={styles.tableLink}>
        <Link linkType={linkType} onClick={() => onClickFn(pageNumber)}>{pageNumber}</Link>
      </div>
    );
  });

  const isPrevNavDisabled = selectedPageNumber === 1;
  const isNextNavDisabled = totalTablePages === selectedPageNumber;

  return (
    <div className={styles.tableFooterContainer}>
      <Row>
        <Col xs={7}>
          <GridContent>
            <span className={styles.spanBlock}>Show</span>
            <div className={styles.elementsPerPage}>
              <Select
                searchable={false}
                options={[
                  { value: 25, label: 25 },
                  { value: 50, label: 50 },
                  { value: 100, label: 100 },
                  { value: 200, label: 200 }
                ]}
                onChange={handleItemsPerPageChange}
                value={{value: elementsPerPage, label: elementsPerPage}}
                selectStyles={selectStyles}
              />
            </div>
            <span>Internal Admins.</span>
            <span className={styles.displayedPagesInfo}>{pagesDisplayedInfo}</span>
          </GridContent>
        </Col>
        <Col xs={5}>
          <GridContent>
            <div className={styles.tableButtonsContainer}>
              <div className={styles.tableLink}>
                {/* eslint-disable max-len */}
                <Link linkType="cancel" disabled={isPrevNavDisabled} onClick={() => !isPrevNavDisabled && handleTableNavChange(1)}>First</Link>
              </div>
              <div className={styles.tableLink}>
                {/* eslint-disable max-len */}
                <Link linkType="cancel" disabled={isPrevNavDisabled} onClick={() => !isPrevNavDisabled && handleTableNavChange(selectedPageNumber - 1)}>Prev</Link>
              </div>
              {pagesButtons}
              <div className={styles.tableLink}>
                {/* eslint-disable max-len */}
                <Link linkType="cancel" disabled={isNextNavDisabled} onClick={() => !isNextNavDisabled && handleTableNavChange(selectedPageNumber + 1)}>Next</Link>
              </div>
              <div className={styles.tableLink}>
                {/* eslint-disable max-len */}
                <Link linkType="cancel" disabled={isNextNavDisabled} onClick={() => !isNextNavDisabled && handleTableNavChange(totalTablePages)}>Last</Link>
              </div>
            </div>
          </GridContent>
        </Col>
      </Row>
    </div>
  );
};

InternalAdminsTableFooter.propTypes = {
  styles: PropTypes.object.isRequired,
  totalRecords: PropTypes.number,
  totalTablePages: PropTypes.number,
  elementsPerPage: PropTypes.number,
  selectedPageNumber: PropTypes.number,
  startPaginationRange: PropTypes.number,
  endPaginationRange: PropTypes.number,
  fromPageCount: PropTypes.number,
  toPageCount: PropTypes.number,
  handleItemsPerPageChange: PropTypes.func,
  handleTableNavChange: PropTypes.func,};

export default themeable(InternalAdminsTableFooter);
